import { getAppIdByPath } from '@/core/Utils'

export enum AppCategory {
  SYSTEM, // 系统保留字段，主要用于中台基座内模块使用，不会显示在菜单中
  TEST, // 保留给开发测试用的类型
  FILE,
  NOTE,
  DEMO,
  DOCK,
  DOCUMENT,
}

// 系统保留APP ID，其他业务微应用不得使用
export enum SystemAppId {
  LOCAL_DEV = 'local',
  SYSTEM = 'sys',
  NC_DEMO = 'test_nc_demo',
  TRANSMISSION_CENTER = 'sys_trans',
  DEV_INTEGRATION = 'test_integration',
}

// 真实业务微应用ID
export enum MicroAppId {
  FILE_MANAGER = 'file',
  KINGSOFT_DOCUMENT = 'kdocs',
  QQ_DOCUMENT = 'qqdocs',
  STICKY_NOTES = 'sticky-notes',
  TRANSFER_DOCK = 'transfer-dock',
  CLOUD_DOCUMENT = 'cloud-document',
  // TODO: 仅用于测试环境，在预发布及正式环境中不会在appList中存在
  LOCAL_DEV = 'local',
  NC_DEMO = 'test_nc_demo',
  DEV_INTEGRATION = 'test_integration',
}

// 跨端文件包含内容
export const FileManagerList: MicroAppId[] = [
  MicroAppId.FILE_MANAGER,
  MicroAppId.KINGSOFT_DOCUMENT,
  MicroAppId.QQ_DOCUMENT,
]

const microAppIdMap = new Map<string, MicroAppId>(Object.values(MicroAppId).map((v) => [v, v]))

export function convertToMicroAppId(appId: string | undefined): MicroAppId | undefined {
  if (!appId) return undefined

  return microAppIdMap.get(appId)
}

export function getMicroAppIdFromUrl(url: string | undefined, baseURL?: string): MicroAppId | undefined {
  if (!url) return undefined

  const appId = getAppIdByPath(url, baseURL)

  return convertToMicroAppId(appId)
}
